import { render } from "./Amount.vue?vue&type=template&id=70e0fb96&scoped=true&ts=true"
import script from "./Amount.vue?vue&type=script&lang=ts"
export * from "./Amount.vue?vue&type=script&lang=ts"

import "./Amount.vue?vue&type=style&index=0&id=70e0fb96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e0fb96"]])

export default __exports__